<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Ingredients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Set Ingredients",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Ingredients",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "consumable.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        product: "",
        quantity: "",
      },
      itemError: "",
      productError: "",
      unitError: "",
      quantityError: "",
      output: {
        name:"", 
        product:"", 
        unit:"", 
        quantity:1, 
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        product: "",
        quantity: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      }
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("consumables", ["Consumables"]),
    ...mapGetters("recipes", ["SaveStatus", "RecipesCart"]),
    ...mapGetters("auth",["MyUserPerm"]),
    ...mapGetters("products", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.RecipesCart ? this.RecipesCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.RecipesCart ? this.RecipesCart.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    }
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchConsumables",
      FetchRecipesCart: "recipes/fetchRecipesCart",
      AddCart: "recipes/addToRecipesCart",
      DeleteCartItem: "recipes/deleteRecipesCart",
      EditCartItems: "recipes/editRecipesCart",
      SaveRecipes: "recipes/addRecipes",
      FetchItems: "products/fetchProducts",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkItem() {
      if (this.data.product != "" && this.data.given_to != "") {
        this.existingItem = this.RecipesCart.filter((item) => {
          return item.item_id == this.data.product && item.givenTo == this.data.given_to;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already in cart for "+this.data.given_to;
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    assignArr(){
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.output.product;
        })
        this.unitsArr = selectedPdt[0].units;
        this.output.unit = this.unitsArr[0].id;
        this.output.name = selectedPdt[0].name;
    },

    resetData() {
      this.data.product = "";
      this.data.given_to = "";
      this.data.reason = "";
      this.data.quantity = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.productError = "";
      this.unitError = "";
      this.quantityError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.recipe_id;
      this.editdata.name = data.consumable.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.consumable.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },

    resetOutput(){
      this.output.product = "";
      this.output.quantity = 1;
      this.output.unit = "";
    },

    saveRecipes() {
      if (this.output.product == "") {
        this.productError = "Product field is required";
      } else {
        this.productError = "";
      }
      if (this.output.unit == "") {
        this.unitError = "Unit field is required";
      } else {
        this.unitError = "";
      }
      this.SaveRecipes(this.output);
      this.resetOutput();
    },
    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });    
    }
  },
  created() {
    this.FetchConsumables();
    this.FetchRecipesCart();
    this.FetchItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="RecipesCart ? RecipesCart : []"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }} {{data.item.unit.name}}
                </template>

                <template #cell(actions)="data">
                  <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!RecipesCart" />

            <b-form v-if="RecipesCart.length>0">              
              <div class="row mt-4">
                <div class="form-group col-md-5">
                  <label>Output <span class="text-danger">*</span></label>
                  <model-list-select
                      :list="Products ? Products : []"
                      v-model="output.product"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Product"
                      @input="resetErrors(), assignArr()"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="productError">
                    <em>{{ productError }}</em>
                  </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                      <label>Unit Measure <span class="text-danger">*</span></label>
                      <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="output.unit"
                      option-value="id"
                      option-text="unitsym"
                      placeholder="Select Unit"
                      @input="resetErrors()"
                      >
                      </model-list-select>
                      <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                      </div>
                  </div>
                </div>
                <div class="form-group col-md-2">
                  <label>Quantity <span class="text-danger">*</span></label>
                  <input
                      type="number"
                      class="form-control"
                      v-model="output.quantity"
                      placeholder="Enter Quantoty"
                  />
                </div>
                <div v-if="MyUserPerm.using_consumables == 1" class="col-md-2 mt-4">
                  <b-button variant="primary" class="pull-center" @click="saveRecipes()"
                  ><i class="fa fa-check"></i> Save
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">

              <div class="form-group mb-3">
                <label>Ingredient <span class="text-danger">*</span></label>
                <model-list-select
                    :list="Consumables ? Consumables : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="nameto_select"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>              
              <div class="form-group mb-3">
                <label>Quantity <span class="text-danger">*</span></label>
                <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="data.quantity"
                    @input="resetErrors()"
                    @keyup.enter="addToCart()"
                    placeholder="Enter Quantity"
                />
                <div class="text-danger" v-if="quantityError">
                  <em>{{ quantityError }}</em>
                </div>
              </div>
              <div class="form-group text-center">
                <b-button
                    @click="addToCart()"
                    variant="primary"
                ><i class="fa fa-plus"></i> Add
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" class="text-primary">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
            type="number"
            class="form-control"
            step="any"
            v-model="editdata.quantity"
        />
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" class="text-danger">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item from cart? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>